export function LegalProvenSlide({ isActive: _ }: { isActive: boolean }) {
  return (
    <div className="flex flex-col h-full">
      <div className="flex flex-row gap-12">
        <div className="flex-1">
          <h2 className="text-[32px] font-light tracking-tight mb-1 font-[family-name:var(--font-heading)]">
            Already used by firms across the UK
          </h2>
          <p className="text-[14px] text-[var(--color-fg-secondary)] leading-relaxed font-light mb-6">
            Our AI paralegal agents are live in immigration, supporting real case preparation with real compliance requirements for real firms.
          </p>

          <p className="text-[10px] font-[family-name:var(--font-mono)] tracking-widest uppercase text-[var(--color-fg-tertiary)] mb-3">
            What the agent does
          </p>
          <ul className="space-y-2.5">
            {[
              "Organises evidence and prepares immigration applications from uploaded documents",
              "Prepares UKVI forms using verified passport, employment, and financial data",
              "Cross-checks supporting documents and flags inconsistencies before review",
              "Reduces hours of manual preparation to minutes per application",
            ].map((item, i) => (
              <li key={i} className="flex items-start gap-2.5">
                <span className="mt-[6px] w-1 h-1 rounded-full shrink-0 bg-[var(--color-accent)]" />
                <span className="text-[13px] text-[var(--color-fg-secondary)] leading-relaxed">{item}</span>
              </li>
            ))}
          </ul>
        </div>

        <div className="w-[35%] shrink-0">
          <div className="flex flex-col justify-start w-full pl-10 -my-4 py-4 gap-5 border-l border-[var(--color-border)]">
            {[
              { value: "15+", label: "UK firms using the platform" },
              { value: "AU / NZ", label: "International deployment" },
              { value: "Hours → min", label: "Preparation time" },
              { value: "95%+", label: "Form accuracy on first pass" },
            ].map((stat) => (
              <div key={stat.label}>
                <div className="text-[28px] font-light tracking-tight mb-1 font-[family-name:var(--font-heading)] text-[var(--color-accent)]">
                  {stat.value}
                </div>
                <div className="text-[10px] text-[var(--color-fg-tertiary)] font-[family-name:var(--font-mono)] uppercase tracking-wider">
                  {stat.label}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="text-left mt-auto mb-8 pb-4 border-b border-[var(--color-border)]">
        <p className="text-[12px] text-[var(--color-fg-secondary)] font-light">
          Built with immigration professionals. Designed for every practice area.
        </p>
      </div>
    </div>
  );
}
